import { PRODUCT } from './in-app-purchase.enum';

export const ENABLE = true;

export const PRODUCTS = [
  {
    id: PRODUCT.UNLOCK_PROTOCOL_ALL_HEALTH,
    code: `UNLOCK_PROTOCOL_ALL_HEALTH`,
    type: `non consumable`
  },
  {
    id: PRODUCT.UNLOCK_PROTOCOL_ANTI_INFLAMMATION,
    code: `unlock_protocol_ANTI_INFLAMMATION`,
    type: `non consumable`
  },
  {
    id: PRODUCT.UNLOCK_PROTOCOL_BLOOD_PRESSURE_MANAGEMENT,
    code: `UNLOCK_PROTOCOL_BLOOD_PRESSURE_MANAGEMENT`,
    type: `non consumable`
  },
  {
    id: PRODUCT.UNLOCK_PROTOCOL_DETOX_AND_CLEANSING,
    code: `UNLOCK_PROTOCOL_DETOX_AND_CLEANSING`,
    type: `non consumable`
  },
  {
    id: PRODUCT.UNLOCK_PROTOCOL_ENERGY_AND_VITALITY,
    code: `UNLOCK_PROTOCOL_ENERGY_AND_VITALITY`,
    type: `non consumable`
  },
  {
    id: PRODUCT.UNLOCK_PROTOCOL_FOCUS_AND_PRODUCTIVITY,
    code: `UNLOCK_PROTOCOL_FOCUS_AND_PRODUCTIVITY`,
    type: `non consumable`
  },
  {
    id: PRODUCT.UNLOCK_PROTOCOL_HYDRATION,
    code: `UNLOCK_PROTOCOL_HYDRATION`,
    type: `non consumable`
  },
  {
    id: PRODUCT.UNLOCK_PROTOCOL_LONGEVITY,
    code: `UNLOCK_PROTOCOL_LONGEVITY`,
    type: `non consumable`
  },
  {
    id: PRODUCT.UNLOCK_PROTOCOL_POSTURE_IMPROVEMENT,
    code: `UNLOCK_PROTOCOL_POSTURE_IMPROVEMENT`,
    type: `non consumable`
  },
  {
    id: PRODUCT.UNLOCK_PROTOCOL_SLEEP_ENHANCEMENT_SYSTEM,
    code: `UNLOCK_PROTOCOL_SLEEP_ENHANCEMENT_SYSTEM`,
    type: `non consumable`
  },
  {
    id: PRODUCT.UNLOCK_PROTOCOL_STRESS_REDUCTION,
    code: `UNLOCK_PROTOCOL_STRESS_REDUCTION`,
    type: `non consumable`
  },
  {
    id: PRODUCT.UNLOCK_PERISCOPE_CALIBRATION_ALL_SOURCES,
    code: 'recalibrate_summary_v_1_0',
    type: `consumable`
  },
  // startof - AsaX Ai Assistant products
  {
    id: PRODUCT.UNLOCK_ASAX_ASSISTANT_360_DNA,
    code: 'dev_asax_assistant_unlock_360_dna',
    type: `consumable`
  },
  {
    id: PRODUCT.PURCHASE_ASAX_ASSISTANT_360_DNA,
    code: 'dev_asax_assistant_360_dna',
    type: `consumable`
  },
  {
    id: PRODUCT.SUBSCRIBE_ASAX_ASSISTANT_3_MONTHS,
    code: 'dev_asax_assistant_3_month',
    type: `paid subscription`
  },
  {
    id: PRODUCT.SUBSCRIBE_ASAX_ASSISTANT_1_YEAR,
    code: 'dev_asax_assistant_1_year',
    type: `paid subscription`
  },
  // endof - AsaX Ai Assistant products
];
